export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const RESET_ERROR = 'RESET_ERROR';

export function setError(error: { message: string }) {
  return {
    type: ERROR_MESSAGE as typeof ERROR_MESSAGE, // as literal type and not string
    payload: error,
  };
}

export function resetError() {
  return {
    type: RESET_ERROR, // as literal type and not string
  };
}

export type SetErrorAction = ReturnType<typeof setError>;
